import { render, staticRenderFns } from "./AdminToolsPopup.vue?vue&type=template&id=36680cae&scoped=true"
import script from "./AdminToolsPopup.vue?vue&type=script&lang=js"
export * from "./AdminToolsPopup.vue?vue&type=script&lang=js"
import style0 from "./AdminToolsPopup.vue?vue&type=style&index=0&id=36680cae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36680cae",
  null
  
)

export default component.exports